import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import { Middleware, getDefaultMiddleware } from '@reduxjs/toolkit';

import { CustomError } from 'core/errors';
import { RootState } from './root-reducer';

const serializeHttpCustomErrorMiddleware: Middleware<
  (action: unknown) => any,
  RootState
> = (store) => (next) => (action) => {
  if (action?.payload instanceof CustomError) {
    return next({ ...action, payload: { ...action.payload } });
  }

  return next(action);
};

export const middleware = [
  serializeHttpCustomErrorMiddleware,
  ...getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
];

export default middleware;
